/**
 * 药品短缺项目接口配置
 *
 */
;
(function(window, $, undefined) {
  // 取得工程目录
  var localObj = window.location;
  var hasSubDomain = false;
  // 是否只有主域名
  var isRootDomain = true;
  var paths = localObj.pathname.split("/");
  var path = "";
  if (paths.length >= 3) {
    path = localObj.pathname.split("/")[1];
    if (paths[3]) {
      hasSubDomain = true;
    }
    if (path) {
      isRootDomain = false;
    }
  }
  var wangzhiheng = "";
  var liangzhiyong = "";
  var basePath = '';
  var basePath1 = '';
  var basePath2 = '';
  var rootDomain = localObj.protocol + "//" + localObj.host;

  // window.wangzhiheng = process.env.NODE_ENV === 'production' ? "http://192.168.20.182:2147/mdb" :"http://192.168.20.182:2147/mdb";
  // window.liangzhiyong = process.env.NODE_ENV === 'production' ? "http://192.168.20.158:2147/mdb" :"http://192.168.20.158:2147/mdb";

  // window.wangzhiheng = process.env.NODE_ENV === 'production' ? "http://192.168.20.6:2147" :"http://192.168.20.6:2147";
  // window.liangzhiyong = process.env.NODE_ENV === 'production' ? "http://192.168.20.6:2147" :"http://192.168.20.6:2147";

  console.log(process.env.BUILD_FLAG)
  console.log(process.env.NODE_ENV)

  if(process.env.BUILD_FLAG === 'devBuild') {//本地部署环境
    wangzhiheng = 'http://192.168.20.208:18010/mdb';  
    liangzhiyong = 'http://192.168.20.208:18010/mdb'; 
    basePath = 'http://192.168.20.208:18010'
    basePath1="http://192.168.20.208:18010"
    // basePath2="http://192.168.101.25:8900"
    var commonUrl = "http://192.168.20.208:18010/sr/";
    var commonIMG = "http://192.168.20.208:18010/sr/";
  } else if(process.env.BUILD_FLAG === 'test') {//测试部署环境
    wangzhiheng = rootDomain+"/mdb";
    liangzhiyong = rootDomain+"/mdb";
    basePath = rootDomain;
    var commonIMG1 = rootDomain +"/sr/";
    var commonUrl = rootDomain+"/sr/";
    var commonIMG = rootDomain+"/sr/";

  } else if(process.env.BUILD_FLAG === 'online') {//线上部署环境
    wangzhiheng = rootDomain+"/mdb";
    liangzhiyong = rootDomain+"/mdb";
    basePath = rootDomain;     
    var commonIMG1 = rootDomain +"/sr/";
    var commonUrl = rootDomain+"/sr/";
    var commonIMG = rootDomain+"/sr/";

  } else {//本地环境


    wangzhiheng = 'http://192.168.20.208:18010/mdb';  
    liangzhiyong = 'http://192.168.20.208:18010/mdb'; 
    basePath = 'http://192.168.20.208:18010'; 
    var commonUrl = "http://192.168.20.208:18010/sr/";
    var commonIMG = "http://192.168.20.208:18010/sr/";

  };

  // 接口调用
  var Action = {
    // 'LOGIN':wangzhiheng+'/login', //用户登录
    'LOGIN':liangzhiyong+'/login', //用户登录
    'GETMENULST':liangzhiyong+'/w/BsRole/getMenuLst', //根据登录账户获取菜单列表

    // 'LOGIN':wangzhiheng1+'/security/mdb/login', //用户登录

    'ECHARTSTOOL':liangzhiyong+'/w/echarts/echartsTool', //echarts图表的信息导入接口
    'USERCORRELATION_LIST':liangzhiyong+'/w/administer/list', //用户列表数据
    'USERCORRELATION_UPDATE':liangzhiyong+'/w/userCorrelation/update', //用户列表数据
    'USERCORRELATION_REGISTER':liangzhiyong+'/w/userCorrelation/register', //用户添加数据
    'RESET':liangzhiyong+'/i/user/pwd/reset', //用户列表重置密码
    'USERCORRELATION_DETELE':liangzhiyong+'/i/user/batDelete', //用户列表删除数据
    'USERCORRELATION_GETUSERBYID':liangzhiyong+'/w/userCorrelation/getUserById', //获取修改的用户信息
    'SMSDATAINFO_CHANGESTATE':liangzhiyong+'/w/smsDataInfo/changeState', //标普数据审核
    'UNLOGINSEACHER_COMMONSEACHER':basePath+'/hxhyapi/unLoginSeacher/commonSeacher', //标普数据审核
    
    'W_MSDATAINFO_IMPORTMSDATA':liangzhiyong+'/w/msDataInfo/importMsData', //质谱上传
    'MSDATAINFO_SELINSTRUMENTHISTORY':liangzhiyong+'/w/msDataInfo/selInstrumentHistory', //质谱历史中选择
    'SMSDATAINFO_SELINSTRUMENTHISTORY':liangzhiyong+'/w/smsDataInfo/selInstrumentHistory', //标普历史中选择
    'LOGOUT':liangzhiyong+'/w/logout', //用户退出
    'GETUSER':liangzhiyong+'/w/userCorrelation/getUser', //用户修改信息
    'USER_PWD_UPDATE':liangzhiyong+'/i/user/pwd/update', //用户修改密码

    'UPDATAUSER':liangzhiyong+'/w/userCorrelation/updateUser', //用户修改信息后的保存信息
    'GETINFO':liangzhiyong+'/w/userCorrelation/getInfo', //用户信息
    'USER_VIEWMENU_LIST':liangzhiyong+'/w/BsRole/getMyMenu', //左侧导航的显示

    'SEARCH_SEARCHSCROLL':wangzhiheng+'/search/searchScroll', //化合物管理列表
    'CHEMICALINFOLIST':wangzhiheng+'/w/chemicalCompoundInfo/chemicalInfoList', //化合物管理列表
    'INSERTCHEMICALINFOT':wangzhiheng+'/w/chemicalCompoundInfo/insertChemicalInfo', //化合物添加
    'DELETECHEMICALINFO':wangzhiheng+'/w/chemicalCompoundInfo/deleteChemicalInfo', //化合物删除
    'SELECTCHEMICALINFO':wangzhiheng+'/w/chemicalCompoundInfo/selectChemicalInfo', //化合物编辑
    'CHEMICA_CHEMILREDIS':wangzhiheng+'/w/chemica/delRedis', //点击 化合物导入
    // 'CHEMICALINFOEXPORT':wangzhiheng+'/w/chemicalCompoundInfo/chemicalInfoExport', //化合物导出
    'CHEMICALINFOEXPORT':wangzhiheng+'/w/chemica/exoprt', //化合物导出
    'CHEMICALONE_FINDPAGELIST':wangzhiheng+'/w/chemicalOne/findPageList',//化合物类型列表
    'CHEMICALONE_SAVEORUPDATE':wangzhiheng+'/w/chemicalOne/saveOrUpdate',//化合物类型添加或编辑
    'CHEMICALONE_DEL':wangzhiheng+'/w/chemicalOne/del',//化合物类型列表删除
    'CHEMICALONE_FINDINFO':wangzhiheng+'/w/chemicalOne/findInfo',//化合物类型查询详细信息
    'CHEMICALTWO_SAVEORUPDATE':wangzhiheng+'/w/chemicalTwo/saveOrUpdate',//新增或修改
    'CHEMICALTWO_FINDINFO':wangzhiheng+'/w/chemicalTwo/findInfo',//查询详细信息
    'CHEMICALTWO_FINDPAGELIST':wangzhiheng+'/w/chemicalTwo/findPageList',//分页查询列表
    'CHEMICALTWO_DEL':wangzhiheng+'/w/chemicalTwo/del', //逻辑删除
    'CHEMICALCATEGORYRELA_IMPORT':wangzhiheng+'/w/chemicalCompoundInfo/import', //化合物数据库
    'CHEMICALCATEGORYRELA_IMPORTCHEMICAL':wangzhiheng+'/w/chemicalCompoundInfo/importChemical', //化合物上传的接口地址
    'MSDATAINFO_GETPROCESS':wangzhiheng+'/w/msDataInfo/getProcessMsData', //状态信息
    
    'SMSDATAINFO_CHANGESMSDATAINFOSTATU':wangzhiheng+'/w/smsDataInfo/changeSmsDataInfoStatu', //标普批量审核
    'SMSDATAINFO_CHANGEMSDATAINFOSTATU':wangzhiheng+'/w/msDataInfo/changeMsDataInfoStatu', //监测批量审核
    'INSTRUMENTINFO_CHEMICALINFOLIST':wangzhiheng+'/w/instrumentInfo/instrumentInfoList', //仪器管理列表
    'INSERTINSTRUMENTINFO':wangzhiheng+'/w/instrumentInfo/insertInstrumentInfo', //仪器添加
    'DELETEINSTRUMENTINFO':wangzhiheng+'/w/instrumentInfo/deleteInstrumentInfo', //仪器删除
    'SELECTINSTRUMENTINFO':wangzhiheng+'/w/instrumentInfo/selectInstrumentInfo', //仪器编辑
    // 'INSTRUMENTINFO_CHEMICALINOFEXPORT':wangzhiheng+'/w/instrumentInfo/chemicalInfoExport', //仪器导出
    
    'INSTRUMENTINFO_CHEMICALINOFEXPORT':wangzhiheng+'/w/chemica/instrument', //仪器导出

    'MSDATALIST':wangzhiheng+'/w/msDataInfo/msDataList', //质谱数据列表
    'DETELEMSDATAINFO':wangzhiheng+'/w/msDataInfo/deleteMsDataInfo', //质谱数据删除
    'SELECTMSDATAINFO':wangzhiheng+'/w/msDataInfo/selectMsDataInfo', //质谱数据编辑
    'INSERTMSDATAINFO':wangzhiheng+'/w/msDataInfo/insertMsDataInfo', //质谱数据增加
    // 'IMPORTMSDATALIST':wangzhiheng+'/w/msDataInfo/importMsDataList', //质谱数据上传
    'IMPORTMSDATALIST':wangzhiheng+'/w/msDataInfo/excelMsData', //质谱数据上传
    'GETPROCESS':wangzhiheng+'/w/msDataInfo/getProcess', //质谱数据上传进度
    'MSDATAINFO_CLEANREDIS':wangzhiheng+'/w/msDataInfo/cleanRedis',//清空化合物用上传任务
    'IMPORTCHEMICALTEMP':wangzhiheng+'/w/chemicalCompoundInfo/saveImport', //导入化合物接口
    // 'MSDATALISTINFO_MSDATALISTINFOEXPORT':wangzhiheng+'/w/msDataInfo/msDataListInfoExport', //质谱数据导出
    'MSDATALISTINFO_MSDATALISTINFOEXPORT':wangzhiheng+'/w/chemica/exoprtMs', //质谱数据导出
    'CHEMICALCOMPOUNDINFO_IMPORT':wangzhiheng+'/w/chemicalCompoundInfo/import', //化合物数据上传
                                        
    'CLEANREDIS':wangzhiheng+'/w/chemicalCompoundInfo/cleanRedis', //清空上传任务
    'DOWNLOADFILE':wangzhiheng+'/w/downloadFile', //质谱数据下载模板
    //'DOWNLOADFILE':wangzhiheng+'/w/msDataInfo/downloadMsDataFile', //质谱数据下载模板


    'SMSDATAINFO_SMSDATALIST':wangzhiheng+'/w/smsDataInfo/smsDataList', //标谱数据列表
    'SMSDATAINFO_DELETESMSDATAINFO':wangzhiheng+'/w/smsDataInfo/deleteSmsDataInfo', //标谱数据删除
    'SMSDATAINFO_SELECTSMSDATALISTINFO':wangzhiheng+'/w/smsDataInfo/selectSmsDataListInfo', //标谱数据编辑
    'SMSDATAINFO_UPDATESMSDATALISTINFO':wangzhiheng+'/w/smsDataInfo/updateSmsDataListInfo', //标普数据操作(添加 / 修改)

    
    'MSDATAINFO_CHANGESTATE':wangzhiheng+'/w/msDataInfo/changeState', //质谱 - 质谱审核
    'MSDATADICTINFO_MSDATADICTLIST':wangzhiheng+'/w/msDataDictInfo/msDataDictList', //质谱数据弹窗列表
    'MSDATADICTINFO_UPDATEMSDATADICTINFO':wangzhiheng+'/w/msDataDictInfo/updateMsDataDictInfo', //质谱数据弹窗列表保存
    'MSDATADICTINFO_DELETEMSDATAINFO':wangzhiheng+'/w/msDataDictInfo/deleteMsDataInfo', //质谱数据弹窗列表删除
    // 'SMSDATAINFO_SMSDATALISTINFOEXPORT':wangzhiheng+'/w/smsDataInfo/smsDataListInfoExport', //标谱数据导出
    'SMSDATAINFO_SMSDATALISTINFOEXPORT':wangzhiheng+'/w/chemica/exoprtSms', //标谱数据导出
    'MSDATAINFO_FINDBASEDATELIST':wangzhiheng+'/w/msDataInfo/findBaseDateList', //监测数据列表
    

    'UPLOADIMG':wangzhiheng+'/w/uploadImg', //上传图片
    'UPLOADPNG': basePath +'/mdb/w/uploadImg', //上传图片
    'UPLOADEDFILE1':  basePath+'/mdb/w/uploadFile', //上传文件
    'UPLOADAUD':  wangzhiheng+'/w/uploadAud', //上传视频
    


    'UPLOADEDFILE':  wangzhiheng+'/w/uploadFile', //上传文件

    'PRODUCTCLASSMAGE_GREENFOODPRODLIST':  basePath+'/dc/w/GreenFoodProdlist/findPageList', //绿色证书列表
     
    
    'W_INDEX_OVERVIEW':  wangzhiheng+'/w/index/overview', //信息概览
    'W_INDEX_MSRANKING':  wangzhiheng+'/w/index/msRanking', //入库监测数据量排行
    'W_INDEX_SMSRANKING':  wangzhiheng+'/w/index/smsRanking', //入库质谱图数量排行
   
    'MSDATALISTAll':wangzhiheng+'/w/msDataInfo/msDataListAll', //质谱数据列表
    'SMSDATAINFO_FINDALLSMSDARALIST':wangzhiheng+'/w/smsDataInfo/findAllSmsDaraList', //标谱数据列表
    'SMSDATAINFO_FINDBASEDATELIST':wangzhiheng+'/w/msDataInfo/findBaseDateList', //标谱数据列表

    'UNITSUBUSER_GETLOGINBASEINFO':wangzhiheng+'/w/unitSubUser/getLoginBaseInfo', //获取用户标识接口



   

    //gh
    "ABOUTINFOLIST" : basePath  + '/hxhyapi/w/aboutInfo/aboutInfoList',//列表信息（关于我们/帮助中心）
    "ABOUTINFOEDIT" : basePath  + '/hxhyapi/w/aboutInfo/aboutInfoEdit',//添加信息（关于我们/帮助中心）
    "FINDABOUTINFO" : basePath  + '/hxhyapi/w/aboutInfo/findaboutInfo',//查询信息（关于我们/帮助中心）
    "ABOUTINFODEL" : basePath  + '/hxhyapi/w/aboutInfo/aboutInfoDel',//删除信息（关于我们/帮助中心）
    "ADVERTISINGLOCATIONINFOLIST" : basePath  + '/hxhyapi/w/advertisingLocationInfo/advertisingLocationInfoList',//广告位列表分页查询列表
    "ADVERTISINGINFOLIST" : basePath  + '/hxhyapi/w/advertisingInfo/advertisingInfoList',//广告位列表信息
    "ADVERTISINGINFOEDIT" : basePath  + '/hxhyapi/w/advertisingInfo/advertisingInfoEdit',//广告位列表信息添加
    "FINDADVERTISINGINFO" : basePath  + '/hxhyapi/w/advertisingInfo/findadvertisingInfo',//广告位列表信息详情
    "ADVERTISINGINFODEL" : basePath  + '/hxhyapi/w/advertisingInfo/advertisingInfoDel',//广告位列表信息删除
    "SPECIALMAGEEDIT" : basePath  + '/hxhyapi/w/specialMage/specialMageEdit',//专题添加
    "FINDSPECIALMAGELIST" : basePath  + '/hxhyapi/w/specialMage/findspecialMageList',//专题列表
    "SPECIALMAGEDEL" : basePath  + '/hxhyapi/w/specialMage/specialMageDel',//专题删除
    "FINDSPECIALMAGEINFO" : basePath  + '/hxhyapi/w/specialMage/findSpecialMageInfo',//专题删除
    "MHINFOLIST" : basePath  + '/hxhyapi/w/mhInfo/mhInfoList',//专题删除
    "BATUPDATE" : basePath  + '/hxhyapi/i/user/login/batUpdate',//用户冻结
    "ADVERTISINGLOCATIONINFOEDIT" : basePath  + '/hxhyapi/w/advertisingLocationInfo/advertisingLocationInfoEdit',//后台广告位管理


    "W_MANAGEMENT_UPDATE" : liangzhiyong  + '/w/management/update',//修改管理员用户的基本信息,以及权限菜单
    "W_MANAGEMENT_ADD" : liangzhiyong  + '/w/management/add',//添加
    "W_MANAGEMENT_UPDACCTSTATE" : liangzhiyong  + '/w/management/updAcctState',//修改状态
    "W_OPINRETROAMAGE_PAGE" : basePath  + '/hxhyapi/w/OpinRetroaMage/page',//获取意见反馈管理分页列表
    "W_OPINRETROAMAGE_UPDATE" : basePath  + '/hxhyapi/w/OpinRetroaMage/update',//修改意见反馈管理
    "W_COMMCLASSMAGE_SAVEORUPDATE" : basePath  + '/hxhyapi/w/commClassMage/saveOrUpdate',//新增修改分类
    "W_COMMCLASSMAGE_FINDCOMMCLASSMAGETREE" : basePath  + '/hxhyapi/w/commClassMage/findCommClassMageTree',//查询分类列表(树结构)
    "W_COMMCLASSMAGE_FINDINFO" : basePath  + '/hxhyapi/w/commClassMage/findInfo',//查看分类详情
    "W_COMMCLASSMAGE_LOGICDEL" : basePath  + '/hxhyapi/w/commClassMage/logicDel',//删除分类

    
    "AREAMAGE_GETCODES": basePath + "/mdb/linkageList", //获取行政区划联动列表
    "W_PMAGE_PAGE" : basePath  + '/dc/w/PMage/page',//获取产品管理分页列表
    "W_PMAGE_PREVIEW" : basePath  + '/dc/w/PMage/preview',//预览产品信息
    "W_PMAGE_DELETE" : basePath  + '/dc/w/PMage/delete',//删除信息
    "W_PMAGE_UPDATESTATUS" : basePath  + '/dc/w/PMage/updateStatus',//编辑状态(提交,申请变更)
    "W_PGEOINFO_FINDPAGELIST" : basePath  + '/dc/w/pGeoInfo/findPageList',//地标信息列表
    "W_PGEOINFO_DEL" : basePath  + '/dc/w/pGeoInfo/del',//地标信息列表删除
    "W_PGEOINFO_FINDINFO" : basePath  + '/dc/w/pGeoInfo/findInfo',//地标信息列表详情
    "W_PGEOINFO_SAVEORUPDATE" : basePath  + '/dc/w/pGeoInfo/saveOrUpdate',//地标信息列表添加编辑
    "W_PGEOINFO_SELPDETAILLIST" : basePath  + '/dc/w/pGeoInfo/selPDetailList',//地标信息列表详情初始化
    "W_REPLENISH_SELMTYXCOUNT" : basePath  + '/dc/replenish/selMtyxCount',//名特优产品

    


    
    



    "W_PROJECTTYPEMAGE_PAGE" : basePath  + '/dc/w/ProjectTypeMage/page',//获取项目类型分页列表
    "W_PROJECTTYPEMAGE_SAVEORUPDATE" : basePath  + '/dc/w/ProjectTypeMage/saveOrUpdate',//新增/修改项目类型
    "W_PROJECTTYPEMAGE_DELETE" : basePath  + '/dc/w/ProjectTypeMage/delete',//删除项目类型
 
    "W_SAMPLINKMAGE_SAVEORUPDATE" : basePath  + '/dc/w/SampLinkMage/saveOrUpdate',//新增/修改采样环节管理
    "W_SAMPLINKMAGE_PAGE" : basePath  + '/dc/w/SampLinkMage/page',//获取采样环节管理分页列表
    "W_PRODUCTCLASSMAGE_LIST" : basePath  + '/dc/w/ProductClassMage/list',//获取农产品分类管理列表
    "W_SAMPLINKMAGE_DELETE" : basePath  + '/dc/w/SampLinkMage/delete',//删除采样环节
    "W_SAMPLINKMAGE_GET" : basePath  + '/dc/w/SampLinkMage/get',//查询采样环节管理

    "W_PRODUCTCLASSMAGE_FINDCLASSMAGETREE" : basePath  + '/dc/w/ProductClassMage/findClassMageTree',//获取农产品分类树结构
    "W_MEDICINALCLASSMAGE_FINDCLASSMAGETREE" : basePath  + '/dc/w/medicinalClassMage/findClassMageTree',//获取中药材分类树结构
    'ZYC_PRODUCTCLASSMAGE_FINDCLASSMAGETREE': liangzhiyong + '/w/MedicinelGbClassMage/findClassMageTree',//获取中药材树形列表
    'ZYC_PRODUCTCLASSMAGE_FINDINFO': liangzhiyong + '/w/MedicinelGbClassMage/findInfo',//获取中药材详情
    'ZYC_PRODUCTCLASSMAGE_SAVEORUPDATE': liangzhiyong + '/w/MedicinelGbClassMage/saveOrUpdate',//新增/修改中药材
    'ZYC_PRODUCTCLASSMAGE_DEL': liangzhiyong + '/w/MedicinelGbClassMage/del',//新增/修改中药材
    "W_PRODUCTCLASSMAGE_GET" : basePath  + '/dc/w/ProductClassMage/get',//查询农产品分类管理
    "W_MEDICINALCLASSMAGE_GET" : basePath  + '/dc/w/medicinalClassMage/get',//查询中药材分类管理
    "W_PRODUCTCLASSMAGE_SAVEORUPDATE" : basePath  + '/dc/w/ProductClassMage/saveOrUpdate',//新增/修改农产品分类管理
    "W_MEDICINALCLASSMAGE_SAVEORUPDATE" : basePath  + '/dc/w/medicinalClassMage/saveOrUpdate',//新增/修改中药材分类管理
    "W_PRODUCTCLASSMAGE_BATDELETE" : basePath  + '/dc/w/ProductClassMage/batDelete',//删除农产品分类管理
    "W_MEDICINALCLASSMAGE_BATDELETE" : basePath  + '/dc/w/medicinalClassMage/batDelete',//批量删除中药材分类管理
    "W_IDXUNITMAGE_FINDPAGELIST" : basePath  + '/dc/w/idxUnitMage/findPageList',//分页查询列表
    "W_IDXUNITMAGE_SAVEORUPDATE" : basePath  + '/dc/w/idxUnitMage/saveOrUpdate',//新增或修改
    "W_IDXUNITMAGE_FINDINFO" : basePath  + '/dc/w/idxUnitMage/findInfo',//查询详细信息
    "W_IDXUNITMAGE_DEL" : basePath  + '/dc/w/idxUnitMage/del',//删除
    "IDXUNITMAGE_UPDATEIDXUNITDELFLAG" : basePath  + '/dc/w/idxUnitMage/updateIdxUnitDelflag',//批量删除
    
    "PROJECTMANAGER_SAVEREPORT" : basePath  + '/dc/w/projectManager/saveReport',//新增检测报告
    "W_BSROLE_PAGE" : liangzhiyong  + '/w/BsRole/page',//获取业务用户角色表分页列表
    "W_BSROLE_INSERT" : liangzhiyong  + '/w/BsRole/insert',//新增业务用户角色表
    "W_BSROLE_UPDATE" : liangzhiyong  + '/w/BsRole/update',//修改业务用户角色表
    "W_BSROLE_GETMENULST" : liangzhiyong  + '/w/BsRole/getMenuLst',//获取当前用户可分配的菜单列表(子账户获取的是父账户的)
    "W_BSROLE_GET" : liangzhiyong  + '/w/BsRole/get',//查询业务用户角色表
    "W_BSROLE_BATDELETE" : liangzhiyong  + '/w/BsRole/batDelete',//批量删除业务用户角色表
    
    "W_ORG_LIST" : liangzhiyong  + '/w/org/list',//检测机构用户列表
    "W_ORG_INSERT" : liangzhiyong  + '/w/org/insert',//新增检测机构用户
    "W_ORG_UPDATE" : liangzhiyong  + '/w/org/update',//修改检测机构用户
    "W_ORG_UPDACCTSTATE" : liangzhiyong  + '/w/org/updAcctState',//账号状态修改
    "W_ORG_GETUSER" : liangzhiyong  + '/w/org/getUser',//通过id获取检测机构个人信息
    "W_ORG_DELUSER" : liangzhiyong  + '/w/org/delUser',//删除用户信息
    "W_CHEMICA_ORGUSEREXPORT" : liangzhiyong  + '/w/chemica/orgUserExport',//导出机构管理员
    "W_RISKFILLMAGE_PAGE" : liangzhiyong  + '/w/RiskFillMage/page',//获取信息填报管理分页列表
    "W_RISKFILLMAGE_UPDATESTATUS" : basePath  + '/dc/w/RiskFillMage/updateStatus',//审核填报信息内容
    "PROJECTMANAGER_BATCHDELLOGICBYSAMPIDS" : basePath  + '/dc/w/projectManager/batchDelLogicBySampIds',//根据样品id列表批量删除样品关联信息
    "PROJECTMANAGER_BATCHDELTESTINFO" : basePath  + '/dc/w/projectManager/batchDelTestInfo',//根据样品ID列表和指标ID批量删除检测结果信息


    //shizm
    "W_PGEOINFO_FINDLIST" : basePath  + '/dc/w/pGeoInfo/findList',//模糊查询地理标志列表
    "W_PMAGE_SAVEORUPDATE" : basePath  + '/dc/w/PMage/saveOrUpdate',//新增/修改产品管理
    "W_PMAGE_GET" : basePath  + '/dc/w/PMage/get',//查询产品详情
    "W_PVARMAGE_PAGE" : basePath  + '/dc/w/PVarMage/list',//获取产品品种管理分页列表
    "W_PVARMAGE_SAVEORUPDATE" : basePath  + '/dc/w/PVarMage/saveOrUpdate',//新增/修改产品品种管理
    "W_PVARMAGE_GET" : basePath  + '/dc/w/PVarMage/get',//查看产品品种详情
    "W_PVARMAGE_DELETE" : basePath  + '/dc/w/PVarMage/delete',//删除产品品种
    "W_PBRANDMAGE_PAGE" : basePath  + '/dc/w/PBrandMage/list',//获取产品品牌管理分页列表
    "W_PBRANDMAGE_SAVEORUPDATE" : basePath  + '/dc/w/PBrandMage/saveOrUpdate',//新增/修改产品品牌管理
    "W_PBRANDMAGE_GET" : basePath  + '/dc/w/PBrandMage/get',//查看产品品牌详情
    "W_PBRANDMAGE_DELETE" : basePath  + '/dc/w/PBrandMage/delete',//删除品牌
    "W_PCERTMAGE_UPDATE" : basePath  + '/dc/w/PCertMage/update',//新增/修改产品认证管理
    "W_PCERTMAGE_PAGE" : basePath  + '/dc/w/PCertMage/list',//获取产品认证管理分页列表
    "W_PCERTMAGE_GET" : basePath  + '/dc/w/PCertMage/get',//查询产品认证管理
    "W_PCERTMAGE_DELETE" : basePath  + '/dc/w/PCertMage/delete',//删除产品认证管理
    "W_PAREAMAGE_SAVEORUPDATE" : basePath  + '/dc/w/pAreaMage/saveOrUpdate',//新增/修改产品产地管理
    "W_PAREAMAGE_GET" : basePath  + '/dc/w/pAreaMage/get',//查询产品产地管理
    "AREA_LINKAGELIST" : basePath + '/mdb/area/linkageList',//获取行政区划列表
    "W_PPROCESSMAGE_PAGE" : basePath  + '/dc/w/pProcessMage/list',//获取产品加工管理分页列表
    "W_PPROCESSMAGE_DELETE" : basePath  + '/dc/w/pProcessMage/delete',//删除产品加工管理
    "W_PPROCESSMAGE_SAVEORUPDATE" : basePath  + '/dc/w/pProcessMage/saveOrUpdate',//新增/修改产品加工管理
    "W_PPROCESSMAGE_GET" : basePath  + '/dc/w/pProcessMage/get',//查询产品加工管理
    "W_PSALEMAGE_SAVEORUPDATE" : basePath  + '/dc/w/pSaleMage/saveOrUpdate',//新增/修改产品销售管理
    "W_PSALEMAGE_LIST" : basePath  + '/dc/w/pSaleMage/list',//获取产品销售管理列表
    "W_PSALEMAGE_GET" : basePath  + '/dc/w/pSaleMage/get',//查询产品销售管理
    "W_PSALEMAGE_DELETE" : basePath  + '/dc/w/pSaleMage/delete',//删除产品销售管理
    "W_PSTORAGEMAGE_SAVEORUPDATE" : basePath  + '/dc/w/PStorageMage/saveOrUpdate',//新增/修改产品储运管理
    "W_PSTORAGEMAGE_GET" : basePath  + '/dc/w/PStorageMage/get',//查询产品储运管理
    "W_PSTORAGEMAGE_LIST" : basePath  + '/dc/w/PStorageMage/list',//获取产品储运管理列表
    "W_PSTORAGEMAGE_DELETE" : basePath  + '/dc/w/PStorageMage/delete',//删除产品储运管理
    "W_PPRODUCEMAGE_SAVEORUPDATE" : basePath  + '/dc/w/pProduceMage/saveOrUpdate',//新增/修改产品生产管理
    "W_PPRODUCEMAGE_LIST" : basePath  + '/dc/w/pProduceMage/list',//获取产品生产管理列表
    "W_PPRODUCEMAGE_GET" : basePath  + '/dc/w/pProduceMage/get',//查询产品生产管理
    "W_PPRODUCEMAGE_DELETE" : basePath  + '/dc/w/pProduceMage/delete',//删除产品生产管理
    "W_PMAGE_SAVEORUPDATE" : basePath  + '/dc/w/PMage/saveOrUpdate',//新增/修改产品管理
    "W_PAREAMAGE_DELETE" : basePath  + '/dc/w/pAreaMage/delete',//删除环境信息

    "W_FRIENDLY_PAGE" : basePath  + '/mdb/w/friendly/page',//获取友情链接分页列表
    "W_FRIENDLY_DELETE" : basePath  + '/mdb/w/friendly/delete',//删除友情链接
    "W_FRIENDLY_SAVEORUPDATE" : basePath  + '/mdb/w/friendly/saveOrUpdate',//新增/修改友情链接
    "W_FRIENDLY_GET" : basePath  + '/mdb/w/friendly/get',//新增/修改友情链接


    "W_BSROLE_GETROLELIST" : liangzhiyong  + '/w/BsRole/getRoleList',//获取业务用户角色所有数据列表(当前用户所有数据) 
    'ADMINISTER_INSERT':liangzhiyong+'/w/administer/insert', //新增管理员用户
    'ADMINISTER_GETUSER':liangzhiyong+'/w/administer/getUser', //通过用户id获取个人信息
    'ADMINISTER_UPDATE':liangzhiyong+'/w/administer/update', //修改管理员用户
    'ADMINISTER_DELUSER':liangzhiyong+'/w/administer/delUser', //删除用户信息
    'ADMINISTER_UPDACCTSTATE':liangzhiyong+'/w/administer/updAcctState', //账号状态修改
    'UNITSUBUSER_FINDPAGE':liangzhiyong+'/w/unitSubUser/findPage', //单位子账户分页列表
    'UNITSUBUSER_SAVE':liangzhiyong+'/w/unitSubUser/save', //单位子账号保存处理
    'UNITSUBUSER_FINDBSROLELIST':liangzhiyong+'/w/unitSubUser/findBsRoleList', //查询当前用户父帐号下所有的自定义角色列表
    'UNITSUBUSER_GETDETAILBYID':liangzhiyong+'/w/unitSubUser/getDetailById', //根据ID查询用户详细信息
    'UNITSUBUSER_LOGINFLAGUPD':liangzhiyong+'/w/unitSubUser/loginFlagUpd', //帐号冻结启用操作
    'UNITSUBUSER_RESETPWD':liangzhiyong+'/w/unitSubUser/resetPwd', //重置密码
    'UNITSUBUSER_LOGICDELBYID':liangzhiyong+'/w/unitSubUser/logicDelById', //根据ID删除用户信息
    'UNITSUBUSER_GETSELFUSERINFO':liangzhiyong+'/w/unitSubUser/getSelfUserInfo', //获取当前登录用户的基本帐号信息
    'UNITSUBUSER_UPDSLEFBASEINFO':liangzhiyong+'/w/unitSubUser/updSlefBaseInfo', //修改用户自己的基本信息
    'UNITSUBUSER_UPDPWD':liangzhiyong+'/w/unitSubUser/updPwd', //通过旧密码修改密码处理
    'UNITSUBUSER_GETLOGINBASEINFO':liangzhiyong+'/w/unitSubUser/getLoginBaseInfo', // 化学数据库用户列表
    'UNITSUBUSER_FINDMEMBPAGE':liangzhiyong+'/w/unitSubUser/findMembPage', //用户信息
    'RISKTASKMAGE_LIST':liangzhiyong+'/w/RiskTaskMage/list', //获取风险任务管理列表


    "W_FLAVOR_SELGEORES" : wangzhiheng  + '/w/flavor/selGeoRes',//特色风味统计信息- 产品信息
    "W_ALLONELIST" : wangzhiheng  + '/n/allOneList',//查询风味类型
    "W_FLAVOR_SELSAMPLECOUNT" : wangzhiheng  + '/w/flavor/selSampleCount',//特色风味统计信息- 样品数据
    "W_FLAVOR_SELCOMPOUDCOUNT" : wangzhiheng  + '/w/flavor/selCompoudCount',//特色风味统计信息- 特征数据
    "W_FLAVOR_SELGEOCOUNT" : wangzhiheng  + '/w/flavor/selGeoCount',//特色风味统计信息- 产品数量
    "W_FWPZ_RADARCOUNT" : basePath  + '/dc/w/fwpz/radarCount',//根据选定的产品进行分析(雷达图)
    "W_FWPZ_FINDSAMPCOUNT" : basePath  + '/dc/w/fwpz/findSampCount',//根据选定的产品进行分析(列表)
    



    
      //zql
     
     
      "PROJECTINFO_PAGE" : basePath + '/dc/w/projectInfo/page',//项目信息-获取项目信息分页列表
      "PROJECTINFO_SAVE" : basePath + '/dc/w/projectInfo/save',//项目信息-新增或者修改项目信息
      "PROJECTINFO_GETALLPROJECTYEAR" : basePath + '/dc/w/projectInfo/getAllProjectYear',//项目信息-获取系统中所有项目年份
      "PROJECTTYPEMAGE_LIST" : basePath + '/dc/w/ProjectTypeMage/list',//获取项目类型列表
      "PROJECTINFO_GETUNITUSERLIST" : basePath + '/dc/w/projectInfo/getUnitUserList',//项目信息-获取主持人、首席专家
      "PROJECTINFO_DOWNPROJECTMATERIAL" : basePath + '/dc/w/projectInfo/downProjectMaterial',//项目信息-下载项目资料
      "PROJECTINFO_GETDETAIL" : basePath + '/dc/w/projectInfo/getDetail',//项目信息-查询项目信息(基本信息+资料信息)
      "PROJECTINFO_DELETELOGIC" : basePath + '/dc/w/projectInfo/deleteLogic',//项目信息-根据ID删除项目信息
      "PROJECTINFO_GETTEMPLATEDETAIL" : basePath + '/dc/w/projectInfo/getTemplateDetail',//项目信息-查询项目信息(项目安全品质评价指标模版明细)
      "PROJECTINFO_SAVETEMPLATE" : basePath + '/dc/w/projectInfo/saveTemplate',//项目信息-新增或者修改项目安全品质评价指标模版明细信息
      "PROJECTTEMPLATE_SAVE" : basePath + '/dc/w/projectTemplate/save',//新增或者修改项目模版信息
      "PROJECTTEMPLATE_PAGE" : basePath + '/dc/w/projectTemplate/page',//获取项目模版分页列表
      "PROJECTTEMPLATE_DELETELOGIC" : basePath + '/dc/w/projectTemplate/deleteLogic',//根据ID删除项目模版
      "GETDETAILBYTEMPLATEID" : basePath + '/dc/w/projectTemplate/getDetailByTemplateId',//查询项目模版明细列表信息
      "PROJECTDATE_PAGE" : basePath + '/dc/w/projectDate/page',//项目数据息-获取项目数据分页列表
      "PROJECTDATE_PAGRGOROTHER" : basePath + '/dc/w/projectDate/pageForOther',//项目数据息-获取项目数据分页列表
      "PROJECTDATE_FINDTITLELIST" : basePath + '/dc/w/projectDate/findTitleList',//项目数据息-项目数据分页列表显示指标列表
      "PROJECTMANAGER_FINDPAGE" : basePath + '/dc/w/projectManager/findPage',//管理项目数据 -分页查询样品信息列表 
      "PROJECTMANAGER_FINDTESTTITLELIST" : basePath + '/dc/w/projectManager/findTestTitleList',//管理项目数据-检测信息列表标题查询  
      "PROJECTMANAGER_FINDSAMPTESTPAGE" : basePath + '/dc/w/projectManager/findSampTestPage',//管理项目数据-检测信息列表分页查询  
      "PROJECTMANAGER_DELTESTINFO" : basePath + '/dc/w/projectManager/delTestInfo',//根据样品ID和指标ID删除检测结果信息  
      "PROJECTMANAGER_DELLOGICBYSAMPID" : basePath + '/dc/w/projectManager/delLogicBySampId',//根据样品id删除样品关联信息    
      "PROJECTMANAGER_GETSAMPTESTITEMDETAIL" : basePath + '/dc/w/projectManager/getSampTestItemDetail',//管理项目数据-某个指标检测项目明细查询 
      "PROJECTMANAGER_SAMPLETESTITEMSAVE" : basePath + '/dc/w/projectManager/sampleTestItemSave',//样品检测项目保存  
      "PROJECTMANAGER_GETDETAIL" : basePath + '/dc/w/projectManager/getDetail',//根据ID查询样品信息详情       
      "PROJECTMANAGER_UPDSAMPBASEINFO" : basePath + '/dc/w/projectManager/updSampBaseInfo',//样品基本信息保存处理
      "PROJECTMANAGER_OBJECTTREELIST" : basePath + '/dc/w/ProductClassMage/findClassMageTree',//样品名称
      'AREA_LINKAGELIST': liangzhiyong +'/area/linkageList',//省市县
      'SAMPLINKMAGE_LIST': basePath + '/dc/w/SampLinkMage/listByType',//获取采样环节管理列表
      'PROJECTJUDGESTD_GETTITLELIST': basePath + '/dc/w/ProjectJudgeStd/getTitleList',//查询监测项目信息 ->传项目id
      'PROJECTJUDGESTD_PAGE': basePath + '/dc/w/ProjectJudgeStd/page',//获取判定标准分页列表
      'PROJECTJUDGESTD_UPDATE': basePath + '/dc/w/ProjectJudgeStd/update',//修改判定标准
      'ARALIMIT_PAGE': basePath + '/dc/w/AraLimit/page',//获取限量标准表分页列表
      'PROJECTJUDGESTD_SETJUDGE': basePath + '/dc/w/ProjectJudgeStd/setJudge',//设定判定标准
      'PROJECTJUDGESTD_SETISJUDGE': basePath + '/dc/w/ProjectJudgeStd/setIsJudge',//对项目进行结果判定
      
      'PROJECTJUDGESTD_INIT': basePath + '/dc/w/ProjectJudgeStd/init', //初始化项目判定数
      // 
      'PROJECTMANAGER_INSPUNITAUTHLIST': basePath + '/dc/w/projectManager/inspUnitAuthList',//智能联想受检企业列表查询
      'PROJECTMANAGER_PRDUTUNITAUTHLIST': basePath + '/dc/w/projectManager/prdutUnitAuthList',//智能联想生产企业列表查询  
      'TEMPLATE_EXPORT': basePath + '/dc/w/sample/template/export',//导入模版下载处理 
      'SAMPLE_SAVEIMPORTDATE': basePath + '/dc/w/sample/saveImportDate',//根据项目ID保存Excel导入的信息
      'SAMPLE_SAMPLEIMPORT': basePath + '/dc/w/sample/sampleImport',//导入样品信息验证处理
      'SAMPLE_DATAEXPORT': basePath + '/dc/w/sample/dataExport',//根据项目ID导出该项目下所有样品信息  
      'PROJECTMANAGER_SAMPLECODECHECK': basePath + '/dc/w/projectManager/sampleCodeCheck',//样品编号唯一的验证处理
      'IDXUNITMAGE_FINDALLLIST': basePath + '/dc/w/idxUnitMage/findAllList',//指标单位列表(全部)
      
      // 'CHEMICALONE_FINDPAGELIST': basePath + '/mdb/w/chemicalOne/findPageList',//一级分类
      'SAMP_FINDTITLELIST': basePath + '/dc/n/index/samp/findTitleList',//门户-项目数据分页列表显示指标列表
      'SAMP_FINDPAGE': basePath + '/dc/n/index/samp/findPage',//门户 -分页查询样品信息列表
      'SAMP_FINDSAMPTESTPAGE': basePath + '/dc/n/index/samp/findSampTestPage',//门户 -检测信息列表分页查询
      'SAMP_FINDTESTTITLELIST': basePath + '/dc/n/index/samp/findTestTitleList',//门户 -检测信息列表标题查询
      'RISKUSER_LIST': basePath + '/dc/w/RiskUser/list',//获取牵头单位列表
      'RISKUSER_PAGE': basePath + '/dc/w/RiskUser/page',//获取系统中专家信息
      'RISKUSER_GET': basePath + '/dc/w/RiskUser/get',//获取默认牵头单位信息
      'ORG_LIST': basePath + '/mdb/w/org/list',//检测机构用户列表
      'PRODUCTCLASSMAGE_FINDCLASSMAGETREE': basePath + '/dc/w/ProductClassMage/findClassMageTree',//获取农产品分类树结构
      'RISKTASKMAGE_SAVEORUPDATE': basePath + '/dc/w/RiskTaskMage/saveOrUpdate',//新增/修改风险任务管理
      'RISKTASKMAGE_PAGE': basePath + '/dc/w/RiskTaskMage/page',//获取风险任务管理分页列表
      
      'RISKTASKMAGE_GET': basePath + '/dc/w/RiskTaskMage/get',//查询风险任务管理
      'RISKTASKMAGE_DELETE': basePath + '/dc/w/RiskTaskMage/delete',//批量删除风险任务管理
      
      'W_RISKTASKMAGE_PAGE': basePath + '/dc/w/RiskTaskMage/page',//获取风险任务管理分页列表
      'W_RISKFILLMAGE_PAGE': basePath + '/dc/w/RiskFillMage/page',//获取信息填报管理分页列表
      'W_RISKFILLMAGE_SAVEORUPDATE': basePath + '/dc/w/RiskFillMage/saveOrUpdate',//新增/修改信息填报管理
      
      'W_RISKFILLMAGE_UPDATESTATUS': basePath + '/dc/w/RiskFillMage/updateStatus',//updateStatus
      'W_UPLOADPNG': basePath +'/mdb/w/uploadImg', //上传图片
      // "W_PRODUCTCLASSMAGE_FINDCLASSMAGETREE" : basePath  + '/w/ProductClassMage/findClassMageTree',//获取农产品分类树结构
      // "W_PRODUCTCLASSMAGE_GET" : basePath  + '/dc/w/ProductClassMage/get',//查询农产品分类管理
      'W_RISKFILLMAGE_GET': basePath + '/dc/w/RiskFillMage/get',//查询信息填报管理
      'W_RISKFILLMAGE_DELETE': basePath + '/dc/w/RiskFillMage/delete',//删除信息填报管理
      'LINK_DICT': basePath + '/dc/w/SampLinkMage/link/dict',//抽样环节


      'ORGAUTHPARAM_FINDCERINFOPAGE': basePath + '/dc/w/orgAuthParam/findCerInfoPage',//授权参数管理-授权参数管理分页列表
      'ORGAUTHPARAM_FINDPAGE': basePath + '/dc/w/orgAuthParam/findPage',//授权参数管理-根据结构资质ID查询授权参数分页列表
      'ORGAUTHPARAM_BATCHDELLOGIC': basePath + '/dc/w/orgAuthParam/batchDelLogic',//授权参数管理-根据机构资质ID删除授权参数
      'ORGAUTHPARAM_IMPORTTEMP': basePath + '/dc/w/orgAuthParam/importTemp',//授权参数管理-下载模板
      'ORGAUTHPARAM_DATAIMPORT': basePath + '/dc/w/orgAuthParam/dataImport',//授权参数管理-上传第一步
      'SAMPLE_IMPORTDATASAVE': basePath + '/dc/w/orgAuthParam/importDataSave',//授权参数管理-上传第二步

      'UNITSUBUSER_FINDDICTLIST': basePath + '/mdb/w/unitSubUser/findDictList',//查询职位/专家类型列表处理

      'W_ORGCERTINFO_SAVEORUPDATE': basePath + '/dc/w/OrgCertInfo/saveOrUpdate',//新增/修改机构资质信息
      'W_ORGCERTINFO_GET': basePath + '/dc/w/OrgCertInfo/get',//新增/修改机构资质信息
      'W_ORGCERTINFO_DELETE': basePath + '/dc/w/OrgCertInfo/delete',//删除机构资质信息
      
      // 法人单位 技术机构
      'W_LEGAL_LIST':  wangzhiheng + '/w/legal/list', // 法人单位用户列表
      'W_LEGAL_INSERT':  wangzhiheng + '/w/legal/insert', // 新增法人单位用户
      'W_LEGAL_UPDATE':  wangzhiheng + '/w/legal/update', // 编辑法人单位用户
      'W_CHEMICA_LEGALENTPEXPORT':  wangzhiheng + '/w/chemica/legalEntpExport', // 导出法人单位列表
      'W_LEGAL_LISTNOPAGE':  wangzhiheng + '/w/legal/listNoPage', // 法人单位用户列表没有分页
      'W_ORG_GETORGINFOBYMEMBID':  wangzhiheng + '/w/org/getOrgInfoByMembId', // 通过membId获取技术机构/法人单位 详细信息

      'W_PROJECTTYPEMAGE_LIST':  basePath + '/dc/w/ProjectTypeMage/list', // 获取项目类型列表
      'W_PROJECTINFO_LIST':  basePath + '/dc/w/projectInfo/list', // 项目信息-获取项目信息分页列表
      'W_MONITORDATA_MONITORVARCOUNT':  basePath + '/dc/w/MonitorData/monitorVarCount', // 各品种检测参数汇总
      'W_MONITORDATA_MONITORVARCOUNTEXCEL':  basePath + '/dc/w/MonitorData/monitorVarCountExcel', // 各品种检测参数汇总导出
      'W_MONITORDATA_QUSELCOUNT':  basePath + '/dc/w/MonitorData/quselCount', // 各检测参数汇总
      'W_MONITORDATA_QUSELCOUNTEXCEL':  basePath + '/dc/w/MonitorData/quselCountExcel', // 各检测参数汇总导出
      'W_MONITORDATA_SAMPLINGLINKLIST':  basePath + '/dc/w/statistics/samplingLinkList', // 抽样环节按品种汇总
      'W_MONITORDATA_SAMPLINGLINKLISTEXCEL':  basePath + '/dc/w/statistics/samplingLinkListExcel', // 抽样环节按品种汇总导出
      'W_MONITORDATA_SAMPLINGLINKTESTITEMEXCEL':  basePath + '/dc/w/statistics/samplingLinkTestItemExcel', // 抽样环节按检测参数汇总导出
      'W_MONITORDATA_SAMPLINGLINKTESTITEM':  basePath + '/dc/w/statistics/samplingLinkTestItem', // 抽样环节按检测参数汇总
      'W_STATISTICS_SAMPLINGCITYPOLLQUERY':  basePath + '/dc/w/statistics/samplingCityPollQuery', // 各城市检测参数汇总
      'W_STATISTICS_SAMPLINGCITYPOLLQUERYEXCEL':  basePath + '/dc/w/statistics/samplingCityPollQueryExcel', // 各城市按检测参数汇总导出
      'W_STATISTICS_SAMPLINGCITYLIST':  basePath + '/dc/w/statistics/samplingCityList', // 各城市按品种汇总
      'W_STATISTICS_SAMPLINGCITYLISTEXCEL':  basePath + '/dc/w/statistics/samplingCityListExcel', // 各城市按品种汇总导出
      // 绿色数据库
       'GREENFOODPRODLIST_FINDPAGELIST':  basePath + '/dc/w/GreenFoodProdlist/findPageList', // 获取门户绿色产品管理分页列表
        'GREENFOODPRODLIST_DEL':  basePath + '/dc/w/GreenFoodProdlist/del', // 批量删除门户绿色产品管理
        'GREENFOODPRODLIST_SAVEORUPDATE':  basePath + '/dc/w/GreenFoodProdlist/saveOrUpdate', // 新增或修改绿色产品管理
        'GREENFOODPRODLIST_FINDINFO':  basePath + '/dc/w/GreenFoodProdlist/findInfo', // 查询详细信息绿色产品管理
         'GREENFOODPRODLIST_EXPORTDATE':  basePath + '/dc/w/GreenFoodProdlist/exportDate', // 导出绿色产品管理
        
      // 产品数据库
      'W_PROTAL_PGEO_PAGE':  basePath + '/dc/w/protal/pGeo/page', // 获取门户产品管理分页列表
      'W_PROTAL_PGEO_DELETE':  basePath + '/dc/w/protal/pGeo/delete', // 批量删除门户产品管理
      'W_PROTAL_PGEO_SAVEORUPDATE':  basePath + '/dc/w/protal/pGeo/saveOrUpdate', // 新增/修改门户产品管理
      'W_PROTAL_PGEO_GET':  basePath + '/dc/w/protal/pGeo/get', // 查询门户产品管理详情
      'W_PINDEXMAGE_PAGE':  basePath + '/dc/w/PIndexMage/page', // 获取产品主要指标管理分页列表
      'W_PINDEXMAGE_SAVEORUPDATE':  basePath + '/dc/w/PIndexMage/saveOrUpdate', // 新增/修改产品主要指标管理
      'W_PINDEXMAGE_DELETE':  basePath + '/dc/w/PIndexMage/delete', // 批量删除产品主要指标管理
      'W_PINDEXMAGE_GET':  basePath + '/dc/w/PIndexMage/get', // 查询产品主要指标管理
      'POFTENINDEX_FINDPAGELIST':  wangzhiheng + '/w/POftenIndex/findPageList', //分页查询常用指标列表
      'POFTENINDEX_BATDELETE':  wangzhiheng + '/w/POftenIndex/batDelete', //批量删除
      'POFTENINDEX_SAVEORUPDATE':  wangzhiheng + '/w/POftenIndex/saveOrUpdate', //新增或修改常用指标
      'POFTENINDEX_FINDINFO':  wangzhiheng + '/w/POftenIndex/findInfo', //查询常用指标详细信息
      'BATCHLABELSTATUS':  basePath + '/dc/w/protal/pGeo/batchLabelStatus', //批量处理产品类型
      
      'PGEO_PINDEXDATASAVEOREDIT':  basePath + '/dc/w/protal/pGeo/pindexDataSaveOrEdit', //指标的编辑/新增
      

      'W_ARALIMIT_PAGE':  basePath + '/dc/w/AraLimit/page', //
      'W_ARALIMIT_SAVEORUPDATE':  basePath + '/dc/w/AraLimit/saveOrUpdate', //
      'W_ARALIMIT_GET':  basePath + '/dc/w/AraLimit/get', //
      'W_ARALIMIT_BATDELETE':  basePath + '/dc/w/AraLimit/batDelete', //
      'W_ARALIMITDATA_PAGE':  basePath + '/dc/w/AraLimitData/page', //
      'W_ARALIMITDATA_SAVEORUPDATE':  basePath + '/dc/w/AraLimitData/saveOrUpdate', //
      'W_ARALIMITDATA_GET':  basePath + '/dc/w/AraLimitData/get', //
      'W_ARALIMITDATA_BATDELETE':  basePath + '/dc/w/AraLimitData/batDelete', //
      'W_ARALIMIT_SETSTANDSTATUS':  basePath + '/dc/w/AraLimit/setStandStatus', //


      
      'PLATFINFOMAGE_PAGE':  basePath + '/dc/w/PlatfInfoMage/page', //科普交流、新闻动态信息管理列表
      'PLATFINFOMAGE_BATDELETE':  basePath + '/dc/w/PlatfInfoMage/batDelete', //删除
      'PLATFINFOMAGE_GET':  basePath + '/dc/w/PlatfInfoMage/get', //详情
      'PLATFINFOMAGE_SAVEORUPDATE':  basePath + '/dc/w/PlatfInfoMage/saveOrUpdate', //新增修改

      'PLATFCOLUMNMAGE_LIST':  basePath + '/dc/w/PlatfColumnMage/list', //栏目管理分页列表
      'PLATFCOLUMNMAGE_GET':  basePath + '/dc/w/PlatfColumnMage/get', //栏目管理详情
      'PLATFCOLUMNMAGE_DELETE':  basePath + '/dc/w/PlatfColumnMage/delete', //栏目管理删除
      'PLATFCOLUMNMAGE_SAVEORUPDATE':  basePath + '/dc/w/PlatfColumnMage/saveOrUpdate', //栏目管理新增修改

      'ABOUTINFO_LIST':  basePath + '/dc/w/AboutInfo/page', //关于我们列表
      'ABOUTINFO_DELETE':  basePath + '/dc/w/AboutInfo/delete', //关于我们列表删除
      'ABOUTINFO_SAVEORUPDATE':  basePath + '/dc/w/AboutInfo/saveOrUpdate', //新增修改
      'ABOUTINFO_GE':  basePath + '/dc/w/AboutInfo/get', //查看详情


      'ADVERSPACEMAGE_LIST':  basePath + '/dc/w/AdverSpaceMage/list', //广告管理列表
      'ADVERSPACEMAGE_GET':  basePath + '/dc/w/AdverSpaceMage/get', //广告管理列表详情
      'ADVERSPACEMAGE_SAVEORUPDATE':  basePath + '/dc/w/AdverSpaceMage/saveOrUpdate', //修改广告管理

      'ADVERMAGE_PAGE':  basePath + '/dc/w/AdverMage/page', //广告列表
      'ADVERMAGE_GET':  basePath + '/dc/w/AdverMage/get', //广告管详情
      'ADVERMAGE_SAVEORUPDATE':  basePath + '/dc/w/AdverMage/saveOrUpdate', //修改广告
      'ADVERMAGE_DELETE':  basePath + '/dc/w/AdverMage/delete', //删除广告
      'UPLOADAUD': basePath +'/mdb/w/uploadAud', //上传视频
      
      'W_FLOORCONFMAGE_PROJECTRECDMAGE':  basePath + '/dc/w/floorConfMage/projectRecdMage', //产品推荐配置信息
      'W_FLOORCONFMAGE_OTHERFLOORINFO':  basePath + '/dc/w/floorConfMage/otherFloorInfo', //一楼以外的其他楼层配置
      'W_FLOORCONFMAGE_SAVEFLOORCONFINFO':  basePath + '/dc/w/floorConfMage/saveFloorConfInfo', //保存楼层标题和描述信息(区域特色产品推荐以外的楼层)
      'W_FLOORCONFMAGE_SAVEAREARECD':  basePath + '/dc/w/floorConfMage/saveAreaRecd', //保存楼层标题和描述信息(区域特色产品推荐楼层)
      'W_FLOORCONFMAGE_FINDLISTFORFLOOR':  basePath + '/dc/w/floorConfMage/findListForFloor', //时令产品推荐/区域特色产品-地理标志信息查询处理
      'W_FLOORCONFMAGE_BACHEGEOSAVE':  basePath + '/dc/w/floorConfMage/bacheGeoSave', //时令产品推荐/区域特色产品推荐-楼层产品批量启用停用处理
      'W_FLOORCONFMAGE_FLOORGEOINFOSAVE':  basePath + '/dc/w/floorConfMage/floorGeoInfoSave', //时令产品推荐/区域特色-地标产品楼层产品保存处理
      'W_FLOORCONFMAGE_FINDFLOORCLASSPAGE':  basePath + '/dc/w/floorConfMage/findFloorClassPage', //产品分类推荐管理-产品分类推荐列表查询
      'W_FLOORCONFMAGE_CALSSENABLEUPD':  basePath + '/dc/w/floorConfMage/calssEnableUpd', //产品分类推荐管理-产品分类推荐启用停用处理
      'W_FLOORCONFMAGE_BATCHCLASSENABLEFLAG':  basePath + '/dc/w/floorConfMage/batchClassEnableFlag', //产品分类推荐管理-产品分类推荐启用停用批量处理
      'W_FLOORCONFMAGE_BATCHCLASSBYIDS':  basePath + '/dc/w/floorConfMage/batchClassByIds', //产品分类推荐管理-产品根据IDS批量删除处理
      'W_FLOORCONFMAGE_DELCLASSBYID':  basePath + '/dc/w/floorConfMage/delClassById', //产品分类推荐管理-产品根据ID删除处理
      'W_FLOORCONFMAGE_FLOORCLASSMAGESAVE':  basePath + '/dc/w/floorConfMage/floorClassMageSave', //产品分类推荐管理-产品分类推荐管理保存
      'W_FLOORCONFMAGE_FINDGEOLISTFORFLAVORMAP':  basePath + '/dc/w/floorConfMage/findGeoListForFlavorMap', //风味谱图管理-产品分页查询
      'W_FLOORCONFMAGE_FLAVOURGEOSAVE':  basePath + '/dc/w/floorConfMage/flavourGeoSave', //风味谱图管理-新增或者修改地标产品信息
      'W_PROTAL_PGEO_PAGE':  basePath + '/dc/w/protal/pGeo/page', //获取门户产品管理分页列表
      'W_FLOORCONFMAGE_FLAVOURENABLEFLAGUPD':  basePath + '/dc/w/floorConfMage/flavourEnableFlagUpd', //风味谱图管理-根据ID停用启用地标产品信息
      'W_FLOORCONFMAGE_DELFLAVOURBYID':  basePath + '/dc/w/floorConfMage/delFlavourById', //风味谱图管理-根据ID删除地标产品信息
      'W_FLOORCONFMAGE_BATCHDELFLAVURBYIDS':  basePath + '/dc/w/floorConfMage/batchDelFlavurByIds', //风味谱图管理-根据IDS批量删除地标产品信息
      'W_FLOORCONFMAGE_BACHEFLAVOURENABLEFLAG':  basePath + '/dc/w/floorConfMage/bacheFlavourEnableFlag', //风味谱图管理-根据IDS批量停用启用地标产品信息
      'W_FLOORCONFMAGE_AREAMAPSAVE':  basePath + '/dc/w/floorConfMage/areaMapSave', //地理标志-产品新增或者修改处理
      'W_FLOORCONFMAGE_DELAREAMAPBYID':  basePath + '/dc/w/floorConfMage/delAreaMapById', //地理标志-删除产品处理
      'W_FLOORCONFMAGE_FLOOROTHERSAVE':  basePath + '/dc/w/floorConfMage/floorOtherSave', //分类/指标/科普解读保存处理
      'W_FLOORCONFMAGE_FINDPLATFINFOFORFLOOR':  basePath + '/dc/w/floorConfMage/findPlatfInfoForFloor', //科普解读配置-科普解读分页列表
      'W_PROTAL_RISKFILL_PAGE':  basePath + '/dc/w/protal/riskFill/page', //后台选择风险管控产品管理列表分页
      'W_PROTAL_RISKFILL_LIST':  basePath + '/dc/w/protal/riskFill/list', //后台获取风险管控产品管理列表 ->传参为农产品分类id
      'W_PROTAL_RISKFILL_SAVEORUPDATE':  basePath + '/dc/w/protal/riskFill/saveOrUpdate', //后台获取风险管控产品新增修改停用启用
      'W_PROTAL_RISKFILL_DELETE':  basePath + '/dc/w/protal/riskFill/delete', //后台获取风险管控产品删除
      'W_FLOORCONFMAGE_SAVESHOWFLAG':  basePath + '/dc/w/floorConfMage/saveShowFlag', //首页中显示不显示
      'W_FLOORCONFMAGE_UPDRECINDEX':  basePath + '/dc/w/floorConfMage/updRecIndex', //
      'W_FLOORAUTH_REFURBISHPRO':  basePath + '/dc/w/floorAuth/refurbishPro', //时令产品数据刷新
      'W_LSSCONFIGMAGE_PAGE':  basePath + '/dc/w/LssConfigMage/page', //获取机构链接及分站专题配置分页列表
      'W_LSSCONFIGMAGE_SAVEORUPDATE':  basePath + '/dc/w/LssConfigMage/saveOrUpdate', //获取机构链接及分站专题配置添加修改
      'W_LSSCONFIGMAGE_DELETE':  basePath + '/dc/w/LssConfigMage/delete', //获取机构链接及分站专题配置删除
      'W_LSSCONFIGMAGE_DELETE':  basePath + '/dc/w/LssConfigMage/delete', //获取机构链接及分站专题配置删除
      'W_UNITSUBUSER_GETDETAILBYID':  liangzhiyong + '/w/unitSubUser/getDetailById', //

      'W_GETTEMPLATEDETAIL':  basePath + '/dc/w/projectInfo/getTemplateParam', //参数分布接口
      
      'W_PINDEXAVG_PAGE':  basePath + '/dc/w/PIndexAvg/page', //查询平均值数据列表信息
      'W_PINDEXAVG_UPDATE':  basePath + '/dc/w/PIndexAvg/update', //更新均值数据
      'PINDEXAVG_GET':  basePath + '/dc/w/PIndexAvg/get', //查询指标详情 
      'PINDEXAVG_UPDATE':  basePath + '/dc/w/PIndexAvg/update', //更新均值数据
      'PINDEXAVG_AVGLIST':  basePath + '/dc/w/PIndexAvg/avgList', //查询平均值数据列表信息 
      'PINDEXAVG_SAMPLERELATASK':  basePath + '/dc/w/PIndexAvg/sampleRelaTask', //手动同步产品与样品数据信息 
      'PINDEXAVG_ITEMVALUETASK':  basePath + '/dc/w/PIndexAvg/itemValueTask', //手动同步样品指标与均值指标数据信息 
      'PROJECTINFO_GETPROJECTCOUNT':  basePath + '/dc/w/projectInfo/getProjectCount', //获取参数分布的项目总数

      'PROJECTMANAGER_FINDAVGSAMPLEPAGE':  basePath + '/dc/w/projectManager/findAvgSamplePage', //均值指标 -跳转分页查询样品信息列表
      'PROJECTMANAGER_FINDAVGSAMPTESTPAGE':  basePath + '/dc/w/projectManager/findAvgSampTestPage', //均值指标-检测信息列表分页查询
      'PROJECTMANAGER_FINDAVGTESTTITLELIS':  basePath + '/dc/w/projectManager/findAvgTestTitleList', //均值指标-检测信息列表标题查询
      "PROJECTORGMAGE_FINDPAGEBYPROID": basePath +"/zxcyxt/w/projectOrgMage/findPageByProId",//获取项目参与机构管理表分页列表
      "PROJECTORGMAGE_ORGUSERLIST": basePath +"/zxcyxt/w/projectOrgMage/orgUserList",//机构用户列表(项目参与机构)
      "PROJECTORGMAGE_SAVE": basePath +"/zxcyxt/w/projectOrgMage/save",//保存项目参与机构管理表
      "PROJECTORGMAGE_DELBYID": basePath +"/zxcyxt/w/projectOrgMage/delById",//机构移除操作
      "PROJECTORGMAGE_BATCHDEL": basePath +"/zxcyxt/w/projectOrgMage/batchDel",//批量移除机构关联信息
      "PROJECTORGMAGE_FINDTASKPROJECTPAGE": basePath +"/zxcyxt/w/sampTaskMage/findTaskProjectPage",//获取项目分配任务列表
      "PROJECTORGMAGE_FINUNITSUBUSERDPAGE": basePath +"/zxcyxt/w/sampTaskMage/finUnitSubUserdPage",//单位子账户列表查询
      "PROJECTORGMAGE_SAMPTASKLIST": basePath +"/zxcyxt/w/sampTaskMage/sampTaskList",///获取样品任务人员信息列表
      "SAMPTASKMAGE_SAVE": basePath +"/zxcyxt/w/sampTaskMage/save",///保存采样任务人员信息
      "SAMPTASKMAGE_DELBYID": basePath +"/zxcyxt/w/sampTaskMage/delById",//根据ID删除采样任务人员
      "SAMPTASKMAGE_BATCHDEL": basePath +"/zxcyxt/w/sampTaskMage/batDelete",//批量删除样品任务人员
      "EXAMININGREPORT_SAMPREPORTINFO": basePath +"/zxcyxt/w/examiningReport/sampReportInfo",//检测报告信息导出PDF

      // zql 热图
      
      "REPLENISH_FINDCLASSMAGETREE": basePath +"/dc/replenish/findClassMageTree",//tree
      "CHEMICALSEARCHNOPAGE": basePath +"/dc/replenish/chemicalSearchNoPage",//风味指标
      "FINDFLAVORSAMPLEAREA": basePath +"/mdb/w/flavor/findFlavorSampleArea",//根据分类，指标 查询样品分布情况
      'BEETOPIC_OVERVIEW':  basePath + '/mdb/beeTopic/overview', //特征数据总量
      'SELGEOCOUNT' : basePath+ '/dc/replenish/selGeoCount',//地理标志产品
      'SAMPLECOUNT' : basePath+ '/dc/replenish/sampleCount',//入库样品总数
      'PIE_LIST':  basePath + '/mdb/w/pie/list', //监测数据信息列表 
      'PIE_GETPIE':  basePath + '/mdb/w/pie/getPie', //风味谱库覆盖产品情况 
      'REPLENISH_OVERVIEW' : basePath+ '/dc/replenish/overview',//门户统计的6组数字
      'CSCSTANDARDMAGE_PAGE' : basePath+ '/dc/w/cscStandardMage/page',//获取标准数据库分页列表
      'CSCSTANDARDMAGE_DELBYID' : basePath+ '/dc/w/cscStandardMage/delById',//根据ID删除标准数据库
      'CSCSTANDARDMAGE_BATDELETE' : basePath+ '/dc/w/cscStandardMage/batDelete',//批量删除标准数据库
      'CSCSTANDARDMAGE_GETDETAIL' : basePath+ '/dc/w/cscStandardMage/getDetail',//查询标准数据库详细信息
      'CSCSTANDARDMAGE_SAVE' : basePath+ '/dc/w/cscStandardMage/save',// 新增或者修改标准数据库
      
      'CSCMATER_PAGE' : basePath+ '/dc/w/cscmater/page',// 获取标准物质数据库分页列表
      'CSCMATER_BATDELETE' : basePath+ '/dc/w/cscmater/batDelete',// 批量删除标准物质数据库
      'CSCMATER_EXPORTDATA' : basePath+ '/dc/w/cscmater/exportData',// 导出标准物质数据库
      'CSCMATER_IMPORTDATA' : basePath+ '/dc/w/cscmater/importData',// 导入标准物质数据库
      'CSCMATER_CHECKIMPORT' : basePath+ '/dc/w/cscmater/checkImport',// 导入标准物校验接口
      'CSCMATER_SAVEORUPDATE' : basePath+ '/dc/w/cscmater/saveOrUpdate',// 新增/修改标准物质数据库
      'CSCMATER_GET' : basePath+ '/dc/w/cscmater/get',// 查询标准物质数据库
      'IDXUNITMAGE_FINDALLLIST' : basePath+ '/dc/w/idxUnitMage/findAllList',// 量值单位
      'REFERENCE_USER' : basePath+ '/dc/n/reference/user',// 获取研发单位、销售单位列表
      'DISTRIBUTION_GETITEMDISTRIBUTION' : basePath+ '/dc/w/map/distribution/getItemDistribution',// 参数分布处理

      // 品种数据库接口
      'PZVARIETY_PAGE' : basePath+ '/dc/w/variety/page',// 获取品种数据库管理分页列表
      'PZVARIETY_GET' : basePath+ '/dc/w/variety/get',// 查询品种数据库管理
      'PZVARIETY_DELETE' : basePath+ '/dc/w/variety/delete',// 删除品种数据库管理
      'PZVARIETY_SAVEOPUPDATE' : basePath+ '/dc/w/variety/saveOpUpdate',// 新增/修改品种数据库管理
      'PZVARIETY_EXPORT' : basePath+ '/dc/w/variety/export',// 品种导出
      'PZVARIETY_IMPORT' : basePath+ '/dc/w/variety/import',// 品种导入
      'PZVARIETY_CHECKIMPORT' : basePath+ '/dc/w/variety/checkImport',// 检验导入品种数据库数据
      'PGEOINF_SELMAXRZCODE' : basePath+ '/dc/w/pGeoInfo/selMaxRzCode',// 调用产品数据库编号


      
      'INDUSTRY_INFO' : basePath+ '/dc/w/sampDis/industry/info',// 样品分布
      
      'PROJECTINFO_GETSAMPLENAME' : basePath+ '/dc/w/projectInfo/getSampleName',// 样品分布
      "INDUSTRY_FINDPAGELIST": basePath +'/dc/w/sampDis/unit/findPageList',//分部抽样单详情
      "DIST_SAMPLE_INFO": basePath +'/dc/i/applet/samp/dist/sample/info',//分部抽样单详情
      
      "PGEO_EXPORTLIST": basePath +'/dc/w/protal/pGeo/exportList',//导出产品数据库
      "AREA_LIST": basePath +'/mdb/n/area/findAreaTree',//省市县

      "EVALUATION_FINDPAGELIST": basePath +'/dc/w/evaluation/findPageList',//评价项目管理列表查询
      "EVALUATION_FINDINFO": basePath +'/dc/w/evaluation/findInfo',//查看详情
      "EVALUATION_DELEVALUATIONPROJECT": basePath +'/dc/w/evaluation/delEvaluationProject',//删除记录
      
      "EVALUATION_SAVEORUPDATE": basePath +'/dc/w/evaluation/saveOrUpdate',//新增/编辑评价项目
      "GEOPRO_SCANLABELINFO": basePath +'/dc/n/geoPro/scanLabelInfo',//数字品质 - 标签/扫描查询

      'EVALUATION_SAVEAPPLICATIONLABEL' : basePath+ '/dc/w/evaluation/saveApplicationLabel',//申请评价标签

      
      'EVALUATION_LABELPAGE' : basePath+ '/dc/w/evaluation/labelPage',//申请记录

      'EVALUATION_FINDNFTBLACKLIST' : basePath+ '/dc/w/evaluation/findNftBlackList',//申请标签上链列表
      'EVALUATION_FINDPAGESCANRECODERLIST' : basePath+ '/dc/w/evaluation/findPageScanRecoderList',//分页查询扫码列表

      'DATA_COMP_COUNT' : basePath+ '/dc/w/comp/count',//特征数据综合统计
      'DATA_COMP_PGEO_LIST' : basePath+ '/dc/w/comp/pGeo/list',//产品查询模糊列表
      'DATA_COMP_PROJECT_LIST' : basePath+ '/dc/w/comp/project/list',//项目课题查询模糊列表
      'DATA_COMP_CATGLIST' : basePath+ '/dc/w/comp/catgList',//产品分类数据上传情况
      'DATA_COMP_GEOLIST' : basePath+ '/dc/w/comp/geoList',//产品数据上传情况
      'DATA_COMP_ORGLIST' : basePath+ '/dc/w/comp/orgList',//项目参加单位数据上传情况
      'DATA_COMP_SAMPLELIST' : basePath+ '/dc/w/comp/sampleList',//课题数据上传情况
      'DATA_COMP_FINISH' : basePath+ '/dc/w/comp/finish',//刷新页面接口
      'EUROPAAPQSC_FINDPAGELIST' : basePath+ '/dc/w/EuropaApqsc/findPageList',//国外欧盟分页查询列表
      'EUROPAAPQSC_DEL' : basePath+ '/dc/w/EuropaApqsc/del',//国外欧盟逻辑删除
      'EUROPAAPQSC_EXPORTEXCEL' : basePath+ '/dc/w/EuropaApqsc/exportDataList',//导出国外地标产品列表
      'EUROPAAPQSC_SAVEORUPDATE' : basePath+ '/dc/w/EuropaApqsc/saveOrUpdate',//国外欧盟新增或修改
      'EUROPAAPQSC_FINDINFO' : basePath+ '/dc/w/EuropaApqsc/findInfo',//国外欧盟查询详细信息
       'PGILOGO_FINDPAGE' : basePath+ '/dc/w/pGiLogo/findPage',//获取地标产品商标管理分页列表
       'PGILOGO_DELBYID' : basePath+ '/dc/w/pGiLogo/batchDel',//删除地标产品商标管理
       'PGILOGO_SAVE' : basePath+ '/dc/w/pGiLogo/save',//保存地标产品商标管理
       
        'PGILOGO_GETDETAIL' : basePath+ '/dc/w/pGiLogo/getDetail',//查询地标产品商标管理详细信息
        
        'PGILOGO_EXPORTDATE' : basePath+ '/dc/w/pGiLogo/exportDate',//地标产品商标导出 
        'EUROPAAPQSC_SELMAXRZCODE' : basePath+ '/dc/w/EuropaApqsc/selMaxRzCode',//国外欧盟编号自动+1
        'PGILOGO_SELMAXRZCODE' : basePath+ '/dc/w/pGiLogo/selMaxRzCode',//地标产品编号自动+1
        
        'ORGUNIT_FINDPAGE' : basePath+ '/mdb/w/orgUnit/findPage',//法人和机构子账号列表
         'ORGUNIT_FINDORGALLLIST' : basePath+ '/mdb/w/orgUnit/findOrgAllList',//所属机构
          'ORGUNIT_SELMEMBDEATAIL' : basePath+ '/mdb/w/orgUnit/selMembDeatail',//查询子账号详情，机构名称
          
          'ORGUNIT_EXPORTORGMEMBINFO' : basePath+ '/mdb/w/orgUnit/exportOrgMembInfo',//子用户信息导出
          'TASKCOMPLETION_FINDPAGE' : basePath+ '/dc/w/taskCompletion/findPageList',//任务完成列表
          'TASKCOMPLETION_GETTOTAL' : basePath+ '/dc/w/taskCompletion/getTotal',//获取任务完成情况合计
          'TASKCOMPLETION_EXPORT' : basePath+ '/dc/w/taskCompletion/export',//任务完成列表导出
          'PROJECTINFO_LISTS' : basePath+ '/dc/w/projectInfo/lists',//项目信息-获取项目信息分页列表-不分页
          'TASKCOMPLETION_GETCACHE' : basePath+ '/dc/w/taskCompletion/getCache',//获取任务完成情况缓存
          'TASKCOMPLETION_SAVECACHE' : basePath+ '/dc/w/taskCompletion/saveCache',//保存任务完成情况缓存
          'TASKCOMPLETION_EXPORTGREENSAMPLE' : basePath+ '/dc/w/taskCompletion/exportGreenSample',//导出绿色产品
          'TASKCOMPLETION_FINDPAGELISTGREENSAMPLE' : basePath+ '/dc/w/taskCompletion/findGreenList',//查询绿色产品分页列表
          'REPORT_EXPORTREPORT' : basePath+ '/dc/w/report/exportReport',//导出报告
          'REPORT_REPORTISEMPTY' : basePath+ '/dc/w/report/reportIsEmpty',//查询报告是否为空
  };
  
  

  // 设置给全局
  window.Action = Action;
  window.basePath = basePath;
  window.commonUrl = commonUrl;
  window.commonIMG1=commonIMG1
  window.commonIMG = commonIMG;
  window.hasSubDomain = hasSubDomain;
  window.isRootDomain = isRootDomain ;
})(window, window.jQuery);



// WEBPACK FOOTER //
// ./static/js/OstPaths.js